<template>
  <img v-if="src != null" :src="src" class="select-none" />
</template>

<script lang="ts" setup async>
import { Filesystem, Directory, Encoding, type WriteFileResult } from '@capacitor/filesystem';
import { getFileUrl } from '../services/Directus.ts';
import { onMounted, ref, type Ref, watch } from 'vue';

const props = defineProps(['src']);
const filePath = () => `images/${props.src}.png`;
const src: Ref<string | null> = ref<string | null>(null);

function refresh() {
  if (!props.src) {
    return;
  }
  Filesystem.readFile({
    path: filePath(),
    directory: Directory.Cache,
    encoding: Encoding.UTF8,
  })
    .then((file) => {
      src.value = file.data.toString();
    })
    .catch(async (_) => {
      await storeImage(props.src);
      Filesystem.readFile({
        path: filePath(),
        directory: Directory.Cache,
        encoding: Encoding.UTF8,
      }).then((file) => {
        src.value = file.data.toString();
      });
    });
}

async function getBase64(blob: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result); // base64 data URL
      } else {
        reject('Failed to read blob as base64');
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function storeImage(id: string) {
  const response = await fetch(getFileUrl(id));
  if (!response.ok) {
    throw new Error('Failed to fetch asset');
  }
  console.log(`Downloading image ${id}...`);

  const blob = await response.blob();
  const base64: string = (await getBase64(blob)) as string;

  var savedFile: WriteFileResult | null = null;

  try {
    savedFile = await Filesystem.writeFile({
      path: filePath(),
      data: base64,
      directory: Directory.Cache,
      encoding: Encoding.UTF8,
    });
  } catch (e) {
    console.error(`Error saving image ${id}.`, e);
  }

  console.log(savedFile);
  return savedFile;
}

async function ensureCacheDir() {
  try {
    await Filesystem.mkdir({
      directory: Directory.Cache,
      path: '',
    });
  } catch (_) {}
  try {
    await Filesystem.mkdir({
      directory: Directory.Cache,
      path: 'images',
    });
  } catch (_) {}
}

onMounted(async () => {
  await ensureCacheDir();
  refresh();
});

watch(props, () => {
  refresh();
});
</script>
